import { type FC } from 'react'
import classNames from 'classnames'
import { WORKFLOW_KIND_ICONS, WORKFLOW_KIND_LABELS, type WorkflowKind } from '../workflowTags'

interface KindBadgeProps {
  kind: WorkflowKind
}

export const KindBadge: FC<KindBadgeProps> = ({ kind }) => (
  <span
    className={classNames('d-inline-flex align-items-center gap-1 zocks-px-0.75 zocks-py-0.125 rounded-2 paragraph-extra-small medium flex-shrink-0', {
      'zocks-bg-color-primary-light zocks-text-primary-dark': kind === 'agent',
      'border zocks-border-color-gray-300 zocks-text-gray-600': kind === 'workflow',
    })}
  >
    <i className={classNames('bi', WORKFLOW_KIND_ICONS[kind])} aria-hidden='true' />
    {WORKFLOW_KIND_LABELS[kind]}
  </span>
)
